var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000"},React.createElement("path",{"d":"M20 20v2H5v-2h15zM11.957 2l7.207 7.207-1.414 1.414L13 5.871V17h-2V5.785l-4.836 4.836L4.75 9.207 11.957 2z"}))));
}

Upload.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Upload;

Upload.default = Upload;
